/* One contact chooser, with the original advisors and the existing chat API. */
(function () {
  'use strict';
  const access = document.querySelector('[data-at-assistance]');
  if (!access) return;
  const scriptId = 'QuoteFlowChatWidgetScript';
  const scriptUrl = access.dataset.chatSrc;
  const excluded = access.hasAttribute('data-chat-excluded');
  const chooser = access.querySelector('[data-at-help]');
  const trigger = chooser.querySelector('summary');
  const panel = chooser.querySelector('[role="dialog"]');
  const contactTeam = document.querySelector('.at-contact__team');
  const chatButtons = [...document.querySelectorAll('[data-at-open-chat]')];
  const statuses = [...document.querySelectorAll('[data-at-chat-status]')];
  let lastTrigger = trigger;
  let chatTrigger = trigger;
  let chatOpen = false;
  let requestId = 0;
  let loading = null;
  let observedHost = null;
  let hostHidden = false;
  let frame = 0;
  let purchaseLift = 0;
  let materialActionsObstructed = false;
  let restingTrigger = null;

  function syncPurchaseSpace() {
    // Keep an open chooser still, including its focused control. Its height is
    // bounded by the same lift in CSS so the panel stays inside the viewport.
    if (chooser.open) { materialActionsObstructed = false; return; }
    let nextLift = 0;
    let hideForMaterialActions = false;
    if (window.innerWidth <= 749) {
      const actual = trigger.getBoundingClientRect();
      // Always compare against the resting position. Comparing the already
      // raised launcher would alternate between overlapping and not overlapping.
      if (actual.width > 0 && actual.height > 0) {
        restingTrigger = { left: actual.left, right: actual.right, top: actual.top + purchaseLift, bottom: actual.bottom + purchaseLift, viewportWidth: window.innerWidth, viewportHeight: window.innerHeight };
      }
      // A temporarily hidden launcher has a zero rect. Keep its resting box,
      // adjusted for the viewport, so hiding it cannot produce a show/hide loop.
      const base = restingTrigger && { left: restingTrigger.left + window.innerWidth - restingTrigger.viewportWidth, right: restingTrigger.right + window.innerWidth - restingTrigger.viewportWidth, top: restingTrigger.top + window.innerHeight - restingTrigger.viewportHeight, bottom: restingTrigger.bottom + window.innerHeight - restingTrigger.viewportHeight };
      if (!base) { materialActionsObstructed = false; return; }
      const candidates = document.querySelectorAll('form[is="product-form"] [type="submit"], product-form [type="submit"], product-sticky-form [type="submit"], form[is="product-form"] .shopify-payment-button, product-form .shopify-payment-button, button[name="checkout"][form="cart"], .at-product__copy .at-product__actions button, .at-product__copy .at-product__actions a, .at-product__copy .at-product__actions select, .at-product__copy .at-product__information-link, .at-product__copy .at-product__commerce-link, .at-product__copy .at-product__alternatives-link, .at-product__copy summary');
      const obstacles = [...candidates].filter((element) => {
        for (let ancestor = element; ancestor; ancestor = ancestor.parentElement) {
          const style = getComputedStyle(ancestor);
          if (ancestor.hidden || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.opacity === '0') return false;
        }
        return true;
      }).map((element) => ({ rect: element.getBoundingClientRect(), materialAction: Boolean(element.closest('.at-product__copy')) })).filter(({ rect }) => rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.left < base.right && rect.right > base.left);
      // Walking upward through every button also avoids moving onto a second
      // purchase action immediately above the first one (cart + express pay).
      let crossedMaterialAction = false;
      for (const { rect, materialAction } of obstacles.sort((a, b) => b.rect.top - a.rect.top)) {
        if (base.bottom - nextLift > rect.top - 12 && base.top - nextLift < rect.bottom + 12) {
          nextLift = Math.max(nextLift, base.bottom - rect.top + 12);
          crossedMaterialAction ||= materialAction;
        }
      }
      if (crossedMaterialAction && nextLift > 120) {
        hideForMaterialActions = !access.contains(document.activeElement);
        nextLift = hideForMaterialActions ? 0 : purchaseLift;
      }
      nextLift = Math.max(0, Math.min(Math.ceil(nextLift), Math.max(0, base.top - 12)));
    }
    materialActionsObstructed = hideForMaterialActions;
    if (purchaseLift !== nextLift) {
      purchaseLift = nextLift;
      access.style.setProperty('--at-help-purchase-lift', purchaseLift + 'px');
    }
  }

  function isObstructed() {
    return Boolean(document.querySelector('dialog[open], [role="dialog"][open]')) || document.body.classList.contains('has-modal-open') || document.body.classList.contains('project-hub-lock') || document.body.classList.contains('pq-scroll-lock');
  }
  function contactTeamVisible() {
    if (!contactTeam) return false;
    const rect = contactTeam.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth && getComputedStyle(contactTeam).visibility !== 'hidden';
  }
  function setStatus(message) {
    statuses.forEach((status) => { status.textContent = message; status.hidden = !message; });
  }
  function closeChooser(restoreFocus = false, cancelPending = true) {
    if (cancelPending) { requestId++; setStatus(''); }
    chooser.open = false;
    trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus && !access.hidden) lastTrigger.focus({ preventScroll: true });
  }
  function openChooser(opener = trigger) {
    if (isObstructed()) return;
    requestId++;
    lastTrigger = opener;
    if (chatOpen) window.QuoteFlowWidget?.close();
    // A footer entry may reopen the chooser while the inline advisor list is
    // visible. Reveal it before focusing its panel; never hide an open chooser.
    access.hidden = false;
    chooser.open = true;
    trigger.setAttribute('aria-expanded', 'true');
    panel.focus({ preventScroll: true });
  }
  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    if (chooser.open) closeChooser(true);
    else openChooser();
  });
  access.querySelector('[data-at-help-close]').addEventListener('click', () => closeChooser(true));
  document.querySelectorAll('[data-at-open-assistance]').forEach((button) => button.addEventListener('click', () => openChooser(button)));
  document.addEventListener('pointerdown', (event) => {
    if (chooser.open && !access.contains(event.target) && !event.target.closest('[data-at-open-assistance]')) closeChooser();
  });
  document.addEventListener('focusin', (event) => {
    if (chooser.open && !access.contains(event.target)) closeChooser();
    scheduleSync();
  });
  document.addEventListener('quoteflow:widget-opened', () => {
    chatOpen = true;
    closeChooser(false, false);
  });
  document.addEventListener('quoteflow:widget-closed', () => {
    chatOpen = false;
    if (!isObstructed() && !chooser.open) {
      let target = chatTrigger.closest('[data-at-help]') ? trigger : chatTrigger;
      if (target === trigger && access.hidden) {
        const inlineChat = contactTeamVisible() ? contactTeam.querySelector('[data-at-open-chat]') : null;
        if (inlineChat) target = inlineChat;
        else { access.hidden = false; materialActionsObstructed = false; }
      }
      target.focus({ preventScroll: true });
    }
  });

  function syncOverlays() {
    frame = 0;
    const obstructed = isObstructed();
    if (obstructed && chooser.open) closeChooser();
    // Contact already exposes the same advisors and assistant. Suppress only
    // the duplicate closed launcher, without hiding the chat host or focus.
    const duplicateContactEntry = contactTeamVisible() && !chooser.open && !access.contains(document.activeElement);
    if (obstructed || duplicateContactEntry) materialActionsObstructed = false;
    else syncPurchaseSpace();
    const hideAccess = obstructed || duplicateContactEntry || materialActionsObstructed;
    if (access.hidden !== hideAccess) access.hidden = hideAccess;
    const host = document.getElementById('quoteflow-chat-widget');
    if (host !== observedHost) { observedHost = host; hostHidden = false; }
    // The vendor uses a closed shadow root and inline display: block !important.
    // Only toggle its public host while a store dialog is active.
    if (host && hostHidden !== obstructed) {
      host.style.setProperty('display', obstructed ? 'none' : 'block', 'important');
      hostHidden = obstructed;
    }
  }
  function scheduleSync() { if (!frame) frame = requestAnimationFrame(syncOverlays); }
  new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'open', 'class'] });
  // Concept animates the sticky card through inline styles. Observe only those
  // cards so their final visibility is picked up without observing our own lift.
  const stickyObserver = new MutationObserver(scheduleSync);
  document.querySelectorAll('product-sticky-form').forEach((sticky) => stickyObserver.observe(sticky, { subtree: true, attributes: true, attributeFilter: ['style'] }));
  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync, { passive: true });
  window.addEventListener('load', scheduleSync, { once: true });
  syncOverlays();

  function loadChat() {
    if (typeof window.QuoteFlowWidget?.open === 'function') return Promise.resolve(window.QuoteFlowWidget);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      let script = document.getElementById(scriptId) || [...document.scripts].find((entry) => entry.src.split('?')[0] === new URL(scriptUrl, location.href).href.split('?')[0]);
      let created = false;
      if (!script) {
        created = true;
        script = document.createElement('script');
        script.id = scriptId;
        script.src = scriptUrl;
        script.async = true;
        script.dataset.tenant = 'mrparquet';
        script.dataset.api = 'https://flow.mrparquet.com.uy';
        script.dataset.title = 'Asistente virtual · Mr. Parquet';
        script.dataset.subtitle = 'Te ayudamos a elegir';
        script.dataset.color = '#b52b2e';
      }
      const cleanup = () => { clearTimeout(timer); script.removeEventListener('load', ready); script.removeEventListener('error', failed); };
      const ready = () => {
        if (typeof window.QuoteFlowWidget?.open === 'function') { cleanup(); resolve(window.QuoteFlowWidget); }
        else failed();
      };
      const failed = () => { cleanup(); if (typeof window.QuoteFlowWidget?.open !== 'function') script.remove(); reject(new Error('Chat unavailable')); };
      const timer = setTimeout(failed, 12000);
      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', failed, { once: true });
      if (created) document.head.appendChild(script);
    }).catch((error) => { loading = null; throw error; });
    return loading;
  }

  chatButtons.forEach((button) => {
    button.hidden = excluded;
    button.addEventListener('click', async () => {
      if (excluded) return;
      const intent = ++requestId;
      chatTrigger = button;
      chatButtons.forEach((entry) => { entry.disabled = true; });
      setStatus('Abriendo el asistente…');
      try {
        const widget = await loadChat();
        if (intent !== requestId || isObstructed()) { setStatus(''); return; }
        if (!document.getElementById('quoteflow-chat-widget')) throw new Error('Chat unavailable');
        closeChooser(false, false);
        widget.open();
        setStatus('');
      } catch (_) {
        if (intent === requestId) setStatus('El chat no está disponible en este momento. Podés escribirnos por WhatsApp.');
      } finally { chatButtons.forEach((entry) => { entry.disabled = false; }); }
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (chooser.open) { event.preventDefault(); closeChooser(true); }
    else if (document.activeElement?.id === 'quoteflow-chat-widget') window.QuoteFlowWidget?.close();
  });
  // Request the chat bundle only from an explicit virtual-assistant click above.
  // Visiting, hovering and choosing a human advisor do not initialize the chat.
})();
